import React, { useState, useEffect } from "react";



import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    PieChart,
    Pie,
    Cell,
    Legend
} from "recharts";
import API_BASE_URL from "../../apiconfig";

function AnalyticalDashboard() {

    const [registrationCount, setRegistrationCount] = useState(0);
    const [paymentCount, setPaymentCount] = useState(0);
    const [programme1Count, setProgramme1Count] = useState(0);
    const [programme2Count, setProgramme2Count] = useState(0);
    //JMEE
    const [JMEEPaymentDoneCountOfGuwahati, setJMEEPaymentDoneCountOfGuwahati] = useState(0);
    const [JMEEPaymentNotDoneCountOfGuwahati, setJMEEPaymentNotDoneCountOfGuwahati] = useState(0);
    const [JMEEPaymentDoneCountOFJorhat, setJMEEPaymentDoneCountOFJorhat] = useState(0);
    const [JMEEPaymentNotDoneCountOFJorhat, setJMEEPaymentNotDoneCountOFJorhat] = useState(0);

    //JMEE
    const [JLEEPaymentDoneCountOfGuwahati, setJLEEPaymentDoneCountOfGuwahati] = useState(0);
    const [JLEEPaymentNotDoneCountOfGuwahati, setJLEEPaymentNotDoneCountOfGuwahati] = useState(0);
    const [JLEEPaymentDoneCountOFJorhat, setJLEEPaymentDoneCountOFJorhat] = useState(0);
    const [JLEEPaymentNotDoneCountOFJorhat, setJLEEPaymentNotDoneCountOFJorhat] = useState(0);


    useEffect(() => {

        fetchAnalyticalDashboardData();

    }, []);

    const fetchAnalyticalDashboardData = async () => {

        try {

            const token = sessionStorage.getItem("adminToken");

            const response = await fetch(
                `${API_BASE_URL}/API/Admin/ANALYTICAL_DASHBOARD_COUNT`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + token
                    }
                }
            );

            const data = await response.json();
            console.log("Data", data);

            if (response.ok) {
                setRegistrationCount(data.registrationCount || 0);
                setPaymentCount(data.paymentCount || 0);
                setProgramme1Count(data.programme1Count || 0);
                setProgramme2Count(data.programme2Count || 0);
                setJMEEPaymentDoneCountOfGuwahati(data.JMEEPaymentDoneCountOfGuwahati || 0);
                setJMEEPaymentNotDoneCountOfGuwahati(data.JMEEPaymentNotDoneCountOfGuwahati || 0);
                setJMEEPaymentDoneCountOFJorhat(data.JMEEPaymentDoneCountOFJorhat || 0);
                setJMEEPaymentNotDoneCountOFJorhat(data.JMEEPaymentNotDoneCountOFJorhat || 0);
                setJLEEPaymentDoneCountOfGuwahati(data.JLEEPaymentDoneCountOFGuwahati || 0);
                setJLEEPaymentNotDoneCountOfGuwahati(data.JLEEPaymentNotDoneCountOFGuwahati || 0);
                setJLEEPaymentDoneCountOFJorhat(data.JLEEPaymentDoneCountOFJorhat || 0);
                setJLEEPaymentNotDoneCountOFJorhat(data.JLEEPaymentNotDoneCountOFJorhat || 0);

            }

        } catch (error) {

            console.error(error);

        }
    };


    const registrationData = [
        {
            name: "",
            count: registrationCount
        }
    ];

    const paymentData = [
        {
            name: "",
            count: paymentCount
        }
    ];

    const programmeData = [
        {
            name: "JMEE",
            value: programme1Count
        },
        {
            name: "JLEE",
            value: programme2Count
        }
    ];

    const JMEE_CENTRE_COUNT = [
        {
            name: "GUWAHATI",
            success: JMEEPaymentDoneCountOfGuwahati,
            failed: JMEEPaymentNotDoneCountOfGuwahati
        },
        {
            name: "JORHAT",
            success: JMEEPaymentDoneCountOFJorhat,
            failed: JMEEPaymentNotDoneCountOFJorhat
        }
    ];


    const JLEE_CENTRE_COUNT = [
        {
            name: "GUWAHATI",
            success: JLEEPaymentDoneCountOfGuwahati,
            failed: JLEEPaymentNotDoneCountOfGuwahati
        },
        {
            name: "JORHAT",
            success: JLEEPaymentDoneCountOFJorhat,
            failed: JLEEPaymentNotDoneCountOFJorhat
        }
    ];
	
	const totalPaymentReceivedData = [
	    {
	        name: "JMEE",
	        count:
	            JMEEPaymentDoneCountOfGuwahati +
	            JMEEPaymentDoneCountOFJorhat
	    },
	    {
	        name: "JLEE",
	        count:
	            JLEEPaymentDoneCountOfGuwahati +
	            JLEEPaymentDoneCountOFJorhat
	    }
	];

    const COLORS = ["#2563eb", "#16a34a"];

    return (
        <>
            <style>
                {`
					.dashboard-wrapper{
						display:grid;
						grid-template-columns:repeat(3,1fr);
						gap:16px;
					}

					.graph-card{
						background:#ffffff;

						padding:14px;

						border-radius:14px;

						border:1px solid #e2e8f0;

						box-shadow:0 2px 8px rgba(0,0,0,0.04);

						height:280px;
					}

					.graph-card h3{
						margin:0 0 10px;

						font-size:15px;
						font-weight:600;

						color:#1e3a8a;

						text-align:center;
					}

					@media (max-width:992px){

						.dashboard-wrapper{
							grid-template-columns:1fr;
						}

						.graph-card{
							height:300px;
						}
					}
				`}
            </style>

            <div className="dashboard-wrapper">

                {/* Registration */}
                <div className="graph-card">

                    <h3>Registration's</h3>

                    <ResponsiveContainer width="100%" height={220}>

                        <BarChart data={registrationData}>

                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis dataKey="name" />

                            <YAxis />

                            <Tooltip />

                            <Bar
                                dataKey="count"
                                fill="#2563eb"
                                radius={[6, 6, 0, 0]}
                            />

                        </BarChart>

                    </ResponsiveContainer>

                </div>

                {/* Payments */}
                <div className="graph-card">

                    <h3>Payment's</h3>

                    <ResponsiveContainer width="100%" height={220}>

                        <BarChart data={paymentData}>

                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis dataKey="name" />

                            <YAxis />

                            <Tooltip />

                            <Bar
                                dataKey="count"
                                fill="#16a34a"
                                radius={[6, 6, 0, 0]}
                            />

                        </BarChart>

                    </ResponsiveContainer>

                </div>

                {/* Programme Pie */}
                <div className="graph-card">

                    <h3>Programme Wise</h3>

                    <ResponsiveContainer width="100%" height={220}>

                        <PieChart>

                            <Pie
                                data={programmeData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={70}
                                label
                            >

                                {programmeData.map((entry, index) => (
                                    <Cell
                                        key={index}
                                        fill={COLORS[index % COLORS.length]}
                                    />
                                ))}

                            </Pie>

                            <Tooltip />

                            <Legend />

                        </PieChart>

                    </ResponsiveContainer>

                </div>

                <div className="graph-card">

                    <h3>JOINT MCA ENTRANCE EXAMINATION (JMEE)</h3>

                    <ResponsiveContainer width="100%" height={220}>

                        <BarChart data={JMEE_CENTRE_COUNT}>

                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis dataKey="name" />

                            <YAxis />

                            <Tooltip />

                            {/* First Bar */}
                            <Bar
                                dataKey="success"
                                fill="#16a34a"
                                radius={[6, 6, 0, 0]}
                                name="Success Payment"
                            />

                            {/* Second Bar */}
                            <Bar
                                dataKey="failed"
                                fill="#dc2626"
                                radius={[6, 6, 0, 0]}
                                name="Not Done Payment"
                            />

                        </BarChart>

                    </ResponsiveContainer>

                </div>

                <div className="graph-card">

                    <h3>JOINT LATERAL ENTRY EXAMINATION (JLEE)</h3>

                    <ResponsiveContainer width="100%" height={220}>

                        <BarChart data={JLEE_CENTRE_COUNT}>

                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis dataKey="name" />

                            <YAxis />

                            <Tooltip />

                            {/* First Bar */}
                            <Bar
                                dataKey="success"
                                fill="#16a34a"
                                radius={[6, 6, 0, 0]}
                                name="Success Payment"
                            />

                            {/* Second Bar */}
                            <Bar
                                dataKey="failed"
                                fill="#dc2626"
                                radius={[6, 6, 0, 0]}
                                name="Not Done Payment"
                            />

                        </BarChart>

                    </ResponsiveContainer>

                </div>
				
				<div className="graph-card">

				    <h3>PAYMENT RECEIVED COMPARISON</h3>

				    <ResponsiveContainer width="100%" height={220}>

				        <BarChart data={totalPaymentReceivedData}>

				            <CartesianGrid strokeDasharray="3 3" />

				            <XAxis dataKey="name" />

				            <YAxis />

				            <Tooltip />

				            <Bar
				                dataKey="count"
				                fill="#16a34a"
				                radius={[6, 6, 0, 0]}
				            />

				        </BarChart>

				    </ResponsiveContainer>

				</div>


            </div>
        </>
    );
}

export default AnalyticalDashboard;